// Life is a Project — Projects registry
//
// This file is the single source of truth for public project stories
// on /projects. Each entry becomes a card on the /projects hub and a
// full write-up at /projects/:slug.
//
// The array is intentionally empty until a project is genuinely ready
// to be shared. Do NOT add placeholders, private work, or unfinished
// commercial initiatives (e.g. Atlas, YOUR1PLACE). Authenticity over
// apparent completeness.
//
// -----------------------------------------------------------------------------
// Schema (per project)
// -----------------------------------------------------------------------------
// {
//   slug:      "kebab-case-slug",              // becomes /projects/<slug>
//   number:    "N° 001",                       // editorial ordinal
//   status:    "in progress" | "ongoing" | "concluded",
//   year:      "2026" | "2024–2026",           // free-form period
//   location:  "Santo Domingo · International",// optional
//
//   title:      { en, es, nl, fr },            // required in all 4 langs
//   summary:    { en, es, nl, fr },            // one-line kicker
//
//   sections: [                                // rendered in order
//     { key: "overview",   heading: {…}, body: [{…}, {…}] },
//     { key: "problem",    heading: {…}, body: [{…}, {…}] },
//     { key: "idea",       heading: {…}, body: [{…}, {…}] },
//     { key: "development",heading: {…}, body: [{…}, {…}] },
//     { key: "progress",   heading: {…}, body: [{…}, {…}] },
//     { key: "results",    heading: {…}, body: [{…}, {…}] },
//     { key: "lessons",    heading: {…}, body: [{…}, {…}] },
//   ],
//
//   pullQuote:  { text: {…}, attribution: {…} }, // optional
// }
// -----------------------------------------------------------------------------

export const PROJECTS = [
    // Empty until a real project is ready to be published.
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug) || null;
